import type React from 'react';

import {
  SkeletonProfileImage,
  SkeletonImage,
  SkeletonBody,
} from '@xing-com/skeleton';

import * as Styled from './skeleton.styles';

const SkeletonLastItemLoggedout: React.FC = () => (
  <Styled.SkeletonWrapper className="skeletonWrapperLastItem">
    <Styled.SkeletonProfileInfoLastItem amountRows={2} />
    <Styled.SkeletonButton />
  </Styled.SkeletonWrapper>
);

const CompanyCardSkeletonLoggedout: React.FC = () => (
  <Styled.SkeletonWrapper className="skeletonWrapperLoggedout">
    <div>
      <Styled.RelativeWrapper>
        {/* @ts-expect-error FIXME: SC6 */}
        <SkeletonImage size="medium" height="100px" />
        <Styled.AbsoluteWrapper>
          <SkeletonProfileImage size="small" />
        </Styled.AbsoluteWrapper>
      </Styled.RelativeWrapper>
      <Styled.SkeletonProfileInfo>
        <SkeletonBody amountRows={2} />
      </Styled.SkeletonProfileInfo>
    </div>
  </Styled.SkeletonWrapper>
);

const SkeletonIndustriesLoggedout: React.FC = () => (
  <Styled.SkeletonWrapperIndustries>
    <Styled.SkeletonProfileInfo>
      {/* @ts-expect-error FIXME: SC6 */}
      <SkeletonBody amountRows={2} size="small" />
    </Styled.SkeletonProfileInfo>
  </Styled.SkeletonWrapperIndustries>
);
const SkeletonIndustriesLoggedoutLastItem: React.FC = () => (
  <Styled.SkeletonWrapperIndustries>
    <Styled.SkeletonButton />
  </Styled.SkeletonWrapperIndustries>
);

export const SkeletonLoggedOutIndustriesPage: React.FC = () => (
  <Styled.SkeletonRow
    data-testid="skeleton-industries-page"
    className="skeletonRowIndustries"
  >
    <Styled.WrapperRow>
      <SkeletonIndustriesLoggedout />
      <SkeletonIndustriesLoggedout />
      <SkeletonIndustriesLoggedout />
      <SkeletonIndustriesLoggedout />
    </Styled.WrapperRow>
    <Styled.WrapperRow>
      <SkeletonIndustriesLoggedout />
      <SkeletonIndustriesLoggedout />
      <SkeletonIndustriesLoggedout />
      <SkeletonIndustriesLoggedout />
    </Styled.WrapperRow>
  </Styled.SkeletonRow>
);

export const SkeletonLoggedOutIndustriesRow = () => (
  <Styled.SkeletonRow
    data-testid="skeleton-industries-module"
    className="skeletonRowIndustries"
  >
    {/* @ts-expect-error FIXME: SC6 */}
    <Styled.SkeletonHeader amountRows={2} size="small" sizeWide="small" />
    <Styled.WrapperRow>
      <SkeletonIndustriesLoggedout />
      <SkeletonIndustriesLoggedout />
      <SkeletonIndustriesLoggedout />
      <SkeletonIndustriesLoggedout />
      <SkeletonIndustriesLoggedoutLastItem />
    </Styled.WrapperRow>
  </Styled.SkeletonRow>
);

export const CompanyCardsSkeletonLoggedoutPage: React.FC = () => (
  <Styled.SkeletonRow data-testid="skeleton-loggedout-page">
    <Styled.WrapperRow>
      <CompanyCardSkeletonLoggedout />
      <CompanyCardSkeletonLoggedout />
      <CompanyCardSkeletonLoggedout />
      <CompanyCardSkeletonLoggedout />
      <CompanyCardSkeletonLoggedout />
    </Styled.WrapperRow>
  </Styled.SkeletonRow>
);

export const CompanyCardsSkeletonLoggedout = () => (
  <Styled.SkeletonRow data-testid="skeleton-loggedout-body">
    <Styled.SkeletonHeader amountRows={2} />
    <Styled.WrapperRow>
      <CompanyCardSkeletonLoggedout />
      <CompanyCardSkeletonLoggedout />
      <CompanyCardSkeletonLoggedout />
      <CompanyCardSkeletonLoggedout />
      <SkeletonLastItemLoggedout />
    </Styled.WrapperRow>
  </Styled.SkeletonRow>
);
